import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { get } from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress'
import Grid from '@material-ui/core/Grid'
import RateReviewOutlinedIcon from 'components/material-symbol/icons/RateReview'
import { CoachReviewsQuery } from './query'
import CoachReviews from 'components/coach-reviews'
import AskForReviewsModal from 'components/coach-reviews-request'
import EmptyReviews from 'components/empty-page-state'
import Error from 'components/error'
import { useStyles } from './styles'

const CoachReviewsView = () => {
  const classes = useStyles()
  const { data, loading, error, refetch } = useQuery(CoachReviewsQuery)
  const [open, setOpen] = useState(false)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error />

  const coachReviews = get(data, 'GetCoachReviews.coachReviews', []) || []
  const coachProfile = get(coachReviews, '[0].coachProfile', {}) || {}

  const completedReviews = coachReviews
    .filter(review => review)
    .filter(({ status }) => status === 'COMPLETE')

  return (
    <>
      <Grid container spacing={1}>
        <Grid container className={classes.coachProfileCardsContainer}>
          <Grid item xs={12}>
            {completedReviews.length ? (
              <CoachReviews
                coachProfile={coachProfile}
                coachReviews={data.GetCoachReviews}
                open={open}
                setOpen={setOpen}
              />
            ) : (
              <EmptyReviews
                actionFn={() => setOpen(true)}
                IconComp={() => <RateReviewOutlinedIcon fontSize="large" />}
                title="Reviews"
                caption="Feedback from your students will appear here."
                buttonText="Ask for Reviews"
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <AskForReviewsModal {...{ coachReviews, refetch, open, setOpen }} />
    </>
  )
}

export default CoachReviewsView
